import { render, staticRenderFns } from "./SuperAdminLogin.vue?vue&type=template&id=72f7efb3"
import script from "./SuperAdminLogin.vue?vue&type=script&lang=js"
export * from "./SuperAdminLogin.vue?vue&type=script&lang=js"
import style0 from "./SuperAdminLogin.vue?vue&type=style&index=0&id=72f7efb3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports